// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3szsT","itemTitle":"ClientEmergencyInfo_itemTitle__2DW7N","itemText":"ClientEmergencyInfo_itemText__21SZE"};